import { Icon } from "@iconify/react";
import moment from "moment/moment";
import React from "react";
import DeleteHook from "../../../Hooks/DeleteHook";

const ClinicalFindingTableRow = ({ patient, refetch, setRefetch }) => {
  const date = moment(patient?.date).format("DD MMM YYYY");
  return (
    <>
      {/* Right Eye Row */}
      <tr className="hover:bg-slate-50/40">
        <td
          rowSpan="2"
          className="px-6 py-4 text-xs font-bold text-slate-600 border-r border-slate-100 align-middle bg-slate-50/30"
        >
          <div className="flex flex-col gap-2 items-start justify-center">
            <span className="whitespace-nowrap font-extrabold text-slate-800">{date}</span>
            <button
              aria-label="Open delete confirmation"
              onClick={(e) => {
                DeleteHook({
                  refetch,
                  setRefetch,
                  url: `https://servercareseebd.careseebd.com/api/v1/findings/${patient?._id}`,
                });
              }}
              className="p-2 border border-rose-200 text-rose-500 hover:text-white hover:bg-rose-500 rounded-lg transition duration-150"
            >
              <Icon icon="solar:trash-bin-trash-linear" className="text-sm" />
            </button>
          </div>
        </td>
        <td className="px-6 py-3 text-xs font-extrabold text-indigo-650 bg-indigo-50/20 whitespace-nowrap">
          Right
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.sph || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.cyl || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.axis || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.add || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.distance || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.logMar1 || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.near || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.rightEye?.logMar2 || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-600 max-w-xs truncate" title={patient?.rightEye?.clinicalDiagnosis}>
          {patient?.rightEye?.clinicalDiagnosis || "-"}
        </td>
      </tr>

      {/* Left Eye Row */}
      <tr className="hover:bg-slate-50/40 border-b border-slate-100">
        <td className="px-6 py-3 text-xs font-extrabold text-cyan-650 bg-cyan-50/25 whitespace-nowrap">
          Left
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.sph || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.cyl || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.axis || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.add || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.distance || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.logMar1 || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.near || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-650">
          {patient?.leftEye?.logMar2 || "-"}
        </td>
        <td className="px-6 py-3 text-xs font-semibold text-slate-600 max-w-xs truncate" title={patient?.leftEye?.clinicalDiagnosis}>
          {patient?.leftEye?.clinicalDiagnosis || "-"}
        </td>
      </tr>
    </>
  );
};

export default ClinicalFindingTableRow;
